import * as React from "react";
import * as $ from "jquery";

import ConnectedPeopleComp from "./ConnectedPeopleComp";
import ToggleBtn from "../lib/components/ToggleBtn";
import {Select, ISelectItem} from "../lib/components/Select";
import { ComboBox, IComboBoxValues } from "../lib/components/ComboBox";
import Modal from "../lib/components/Modal";
import {EditItemCompCore} from "./EditItemCompCore";

import {IUser, IProileComp, IUserWithDefaultConnection, IEditItemCompProps, IConnnectedPeople, IEditItemCompState} from "../../interfaces/layout/blocks/IUser";

declare var window:any;
export class EditItemCompEvents extends EditItemCompCore{

    constructor(props: IEditItemCompProps) {
        super(props);
    }

    protected emailChangeHandler(event) {
        var data:IUser = this.state.data;
        data.email =  event.target.value.toString().trim();
        this.setState({
            data: data
        } as IEditItemCompState);
    }

    protected passwordChangeHandler(event): void {
        var data:IUser = this.state.data;
        data.password =  event.target.value.toString().trim();
        this.setState({
            data: data
        } as IEditItemCompState);
    }

    protected passwordMChangeHandler(event): void {
        this.setState({
            passwordm: event.target.value.toString().trim()
        } as IEditItemCompState);
    }

    protected submitHandler(e): void {
        e.preventDefault();
        if ( this.props.profileMode === false ) {
            if ( this.props.closeHandler !== undefined ) {
                window.currentModal.setCloseHandlerCb(()=>{
                    this.props.closeHandler();
                });
            }else{
                window.currentModal.setCloseHandlerCb(null);
            }
        }

        if (this.checkValid()) {
            this.save();
        }
    }

    protected closeClickHandler(evt): void {
        evt.preventDefault();
        window.currentModal.close();
    }
    protected removeClickHandler(evt): void {
        evt.preventDefault();
		$.ajax({
	      data:{
	         'id'           : this.id
	      },
	      type:              "POST",
	      url:  			'/user/removeUser',
	      contentType:      "application/x-www-form-urlencoded;charset=UTF-8",
	      success: (data) => {
			    if ( this.props.closeHandler !== undefined ) {
					window.currentModal.setCloseHandlerCb(()=>{
						this.props.closeHandler();
					});
	            }else{
					window.currentModal.setCloseHandlerCb(null);
				}
		        window.currentModal.close();
	      }
	   });
    }

    protected changeTypeHandler(evt, type:string): void {
        evt.preventDefault();
		if ( this.id > 0 ) {
			this.changeType(type);
		}
    }

    protected sexChangeHandler(new_value:string): void {
		var data:IUser = this.state.data;
		data.sex = new_value;
        this.setState({
            data: data
        } as IEditItemCompState);
    }

    protected fieldChangeHandler(evt): void {
        evt.preventDefault();
        var input:HTMLInputElement = evt.target;
        var data:IUser = this.state.data;
        data[input.name] = input.value;
        this.setState({
            data: data
        } as IEditItemCompState);
        if ( input.name === 'firstName' && data.type === 'children' ) {
            if ( this.showOtherParentCombobox() ) {
                // NOTE: ha többneylvü lesz akkor a lastnaem kell
                this.getOtherParentSource();
            }
        }
    }

    protected otherParentChangeHandler(value:string, label:string):void{
        var curr = this.state.otherParent;
        curr.currentValue = value;
        curr.currentLabel = label;
        this.setState({
            otherParent: curr
        } as IEditItemCompState);
    }

    protected allUserChangeHandler(value:string, label:string):void{
        var curr = this.state.data;
        curr.lastName = label;
		if ( parseInt(value) > 0) {
			for (var key in this.state.allUser.source) {
			    var item:any = this.state.allUser.source[key];
				if ( item.value === parseInt(value) ) {
					curr.lastName = item.lastName;
					curr.firstName = item.firstName;
					curr.birthDate = item.birthDate;
					break;
				}
			}
		}
        this.setState({
            data: curr
        } as IEditItemCompState);

		if ( label.trim() !== '' ) {
			$.ajax({
			      data:{
			        	'lastName'           : label,
						'sex'				 : curr.sex
			      },
			      type:               			"POST",
			      url: 							'/user/getUsers',
			      contentType:        	"application/x-www-form-urlencoded;charset=UTF-8",
			      success: (data) => {
			    	var curr = this.state.allUser;
					curr.source = data.source;
					this.setState({
			            allUser: curr
			        } as IEditItemCompState);
			      }
		    });
		}
    }

    protected changeCity(value:string, label:string, coords:any):void{
        var curr = this.state.data;
        curr.city = label;
        curr.cityLat = coords.lat;
        curr.cityLng = coords.lng;
        this.setState({
            data: curr
        } as IEditItemCompState);
    }

    protected changeBirthBirthPlaceCountry(value:string, label:string, coords:any):void{
        var curr = this.state.data;
        curr.birthPlaceCountry = label;
        curr.birthPlaceCountryLat = coords.lat;
        curr.birthPlaceCountryLng = coords.lng;
        this.setState({
            data: curr
        } as IEditItemCompState);
    }

    protected changeBirthPlaceCity(value:string, label:string, coords:any):void{
        var curr = this.state.data;
        curr.birthPlaceCity = label;
        curr.birthPlaceCityLat = coords.lat;
        curr.birthPlaceCityLng = coords.lng;
        this.setState({
            data: curr
        } as IEditItemCompState);
    }

    protected birthDateChangeHandler(evt,index?:number, value?:number):void{
        var temp = this.state.data.birthDate.split('.');
        if ( evt !== undefined ) {
            var input:HTMLInputElement = evt.target;
            var index:number = parseInt(input.dataset.index);
            temp[index] = input.value;
        }else{
            if ( value < 9 ) {
                temp[index] = '0' + value.toString();
            }else{
                temp[index] = value.toString();
            }
        }
        var data = this.state.data;
        data.birthDate = temp.join('.');
        this.setState({
            data: data
        } as IEditItemCompState);
    }

    protected deathDateChangeHandler(evt,index?:number, value?:number):void{
        var temp = this.state.data.deathDate.split('.');
        if ( evt !== undefined ) {
            var input:HTMLInputElement = evt.target;
            var index:number = parseInt(input.dataset.index);
            temp[index] = input.value;
        }else{
            if ( value < 9 ) {
                temp[index] = '0' + value.toString();
            }else{
                temp[index] = value.toString();
            }
        }
        var data = this.state.data;
        data.deathDate = temp.join('.');
        this.setState({
            data: data
        } as IEditItemCompState);
    }

    protected toggleDeathBoxChangeHandler(evt): void {
        evt.preventDefault();
        this.setState({
            showDeathbox: !this.state.showDeathbox
        } as IEditItemCompState);
    }



	protected toggleProfileFormFieldsHandler(evt): void {
		evt.preventDefault();
		this.setState({
			showProfielFromFields: !this.state.showProfielFromFields
		} as IEditItemCompState);
	}
	protected proileFormFieldsChangeHandler(props): void {
		this.setState({
			ProfileFormFieldsData: props
		} as IEditItemCompState);
	}
}



// WEBPACK FOOTER //
// ./components/EditItemCompEvents.tsx